import React = require("react");
import MuiDialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";

export interface ButtonConfig {
    label: string;
    callback: () => void;
    dataTestId?: string;
}

interface DialogProps extends React.Props<Dialog> {
    width?: number;
    contentStyle?: React.CSSProperties;
    autoDetectWindowHeight?: boolean;
    primaryButtonConfig: ButtonConfig;
    secondaryButtonConfig?: ButtonConfig;
}

interface DialogState {
    open: boolean;
}

export default class Dialog extends React.Component<DialogProps, DialogState> {
    static defaultProps = {
        autoDetectWindowHeight: true
    };

    constructor(props: DialogProps) {
        super(props);

        this.state = {
            open: false
        };
    }

    componentDidMount() {
        this.setState({
            open: true
        });
    }

    componentWillUnmount() {
        this.handleClose();
    }

    render() {
        let actions: Array<React.ReactElement<any>> = [];

        let style = {
            zIndex: 200100
        };
        let bodyStyle = {
            padding: 0,
            borderBottom: '1px solid #dddddd',
            backgroundColor: '#f3f3f3'
        };
        let contentStyle = Object.assign({}, {
            width: this.props.width || undefined
        }, this.props.contentStyle);
        let actionsStyle = {
            padding: 18
        };

        if (this.props.secondaryButtonConfig) {
            actions.push(
                <FlatButton
                    data-test-id={this.props.secondaryButtonConfig.dataTestId}
                    label={this.props.secondaryButtonConfig.label}
                    onTouchTap={this.handleSecondaryActionCallback} />
            );
        }
        if (this.props.primaryButtonConfig) {
            actions.push(
                <RaisedButton
                    primary={true}
                    data-test-id={this.props.primaryButtonConfig.dataTestId}
                    label={this.props.primaryButtonConfig.label}
                    onTouchTap={this.handlePrimaryActionCallback} />
            );
        }

        return (
            <MuiDialog open={this.state.open}
                    autoDetectWindowHeight={this.props.autoDetectWindowHeight}
                    actions={actions}
                    contentStyle={contentStyle}
                    bodyStyle={bodyStyle}
                    actionsContainerStyle={actionsStyle}
                    style={style}>
                {this.props.children}
            </MuiDialog>
        );
    }

    private handleClose = () => {
        this.setState({
            open: false
        });
    };

    private handlePrimaryActionCallback = () => {
        this.handleClose();
        if (this.props.primaryButtonConfig.callback) {
            this.props.primaryButtonConfig.callback();
        }
    };

    private handleSecondaryActionCallback = () => {
        this.handleClose();
        if (this.props.secondaryButtonConfig && this.props.secondaryButtonConfig.callback) {
            this.props.secondaryButtonConfig.callback();
        }
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/dialog/Dialog.tsx
 **/